// extracted by mini-css-extract-plugin
export default {"wrapper":"taa","container":"uaa","box":"vaa","title":"waa","rdwrap":"xaa","rditem":"yaa","rdimage":"zaa","name":"Aaa","heading":"Baa","text":"Caa","guarantee":"Eaa","chatbox":"Faa"};
    if(module.hot) {
      // 1714654900368
      var cssReload = require("../../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  